<template>
  <QS-scroller-box>
    <EchoLastData
      :dataList="allPreviewlist"
      :model="renderData.model.topPreviewModel"
    />
    <div class="tip">提示：录入的租赁车辆仅作记录，不会在子订单中创建支付项</div>
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <form-text-box ref="baseInfo"
      :column="3"
      :dataList="renderData.list.leaseFormList"
      :model="renderData.model.leaseModel"
    />
    <template slot="bottomAction">
      <el-button @click="cancel" size="mini">取消</el-button>
      <el-button @click="previousStep" size="mini">上一步</el-button>
      <el-button @click="submit" :loading="loading" size="mini" type="primary">提交</el-button>
    </template>
  </QS-scroller-box>
</template>
<script>
import EchoLastData from '../../../components/EchoLastData.vue'
import { allPreviewlist } from '../../config/echoLastData'

export default {
  components: {
    EchoLastData,
  },
  props: {
    renderData: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      allPreviewlist,
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    previousStep() {
      this.$emit('previousStep')
    },
    submit() {
      this.$emit('submit')
    },
  },
}
</script>
<style scoped lang='scss'>
.tip{
  margin: 20px 0;
  background: #f7f8fa;
  color: #898a8a;
  padding: 5px;
  font-weight: bold;
}
</style>
